<div class="panel panel-default">
	<div class="panel-body">
		<div class="col-md-12" *ngIf="loading">
			<div class="text-center">
				<p>Loading PolarLink events...</p>
				<div class="spinner-border" role="status">
					<span class="sr-only">Loading...</span>
				</div>
			</div>
		</div>
		<div class="col-md-12" *ngIf="!loading && gridData.length > 0">
			<app-grid-v2 [id]="deviceType+'-events'" [columns]="gridColumns" [data]="gridData" [settings]="settings"></app-grid-v2>
		</div>
	</div>

	<div *ngIf="gridData.length == 0 && !loading">
		<div class="panel panel-default">
			<div class="panel-body">
				<strong>No PolarLink Events Found in Selected Period!</strong>
			</div>
		</div>
	</div>
</div>
